import Errors from './Errors'

class Form {
	constructor (data) {
		this.originalData = data

		for (let field in data) {
			this[field] = data[field]
		}

		this.loading = false
		this.errors = new Errors()
	}

	data () {
		let data = {}

		for (let field in this.originalData) {
			data[field] = this[field]
		}

		return data
	}

	submit (requestType, url) {
		this.loading = true

		return new Promise((resolve, reject) => {
			axios[requestType](url, this.data())
				.then(response => {
					this.onSuccess(response.data)

					resolve(response.data)
				})
				.catch(error => {
					this.onFail(error.response.data.errors)

					reject(error.response.data.errors)
				})
				.then(() => {
					this.loading = false
				})
		})

	}

	post (url) {
		return this.submit('post', url)
	}

	onSuccess(data) {
		this.errors.clear();
	}

	onFail(errors) {
		this.errors.record(errors)
	}

	reset () {
		for (let field in this.originalData) {
			this[field] = ''
		}
	}
}

export default Form